import { render, staticRenderFns } from "./Claim-Category.vue?vue&type=template&id=f95cffa8&scoped=true"
import script from "./Claim-Category.vue?vue&type=script&lang=js"
export * from "./Claim-Category.vue?vue&type=script&lang=js"
import style0 from "./Claim-Category.vue?vue&type=style&index=0&id=f95cffa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95cffa8",
  null
  
)

export default component.exports